module.exports = __webpack_public_path__ + "img/linkedIn.9d3d87e7.png";